import React, {MouseEvent, useCallback} from 'react'
import {css} from '@emotion/react'
import {SlctInternalProps, SlctOption} from 'module/Slct/type/SlctType'
import {cssRemoveDisplayValueMultiButton, cssSlctDisplayValueMultiRoot, cssSlctDisplayValueMultiText, cssSlctEllipsis, cssSlctMultiDisabled} from 'module/Slct/style/SlctStyle'
import {SetEvent} from 'type/SetCb'
import {Close} from '@mui/icons-material'
import {useSlctDraggable} from 'module/Slct/hook/useSlctDraggable'
import {TextAlign} from 'type/TextAlign'
import {getTextAlignCSS} from 'module/CustomField/style/CFAlignmentStyle'


interface Props<ModelType extends object | void, ValueType extends string | number> {
	displayValue: string | React.ReactNode
	option: SlctOption<ModelType, ValueType>
	index: number
	disabled?: boolean
	align?: TextAlign
	removeValue: (o: SlctOption<ModelType, ValueType>, evt: SetEvent<HTMLDivElement>) => void
	onMoveOption: SlctInternalProps<ModelType, ValueType>['onMoveOption']
}

export const SlctMultiDisplayValueComponent = React.memo(function SlctMultiDisplayValueComponent<ModelType extends object | void, ValueType extends string | number>(props: Props<ModelType, ValueType>) {
	const {displayValue, option, index, align, removeValue, onMoveOption} = props
	let disabled = props.disabled || option.disabled
	const onClick = useCallback((event: MouseEvent<HTMLDivElement>) => {
		if (event.button !== 0) return;
		removeValue(option, event);
	}, [option, removeValue])
	const slctDraggableProps = useSlctDraggable({option, index, onMoveOption, disabled})

	const cssList = [
		cssSlctDisplayValueMultiRoot,
		disabled ? cssSlctMultiDisabled : undefined,
		css`
			color: ${option.valuecolor || option.color || '#000'};
			background: ${option.valuebackground || option.background || '#ddd'}
		`,
		option.textcss?.trim() ? css(option.textcss) : undefined,
		getTextAlignCSS(align),
	]

	return <div
		{...slctDraggableProps}
		css={cssList}
	>
		<div css={[
			cssSlctDisplayValueMultiText,
			cssSlctEllipsis,
		]}>
			{displayValue}
		</div>
		{!disabled &&
			<div
				css={cssRemoveDisplayValueMultiButton}
				onMouseDown={onClick}>
				<Close fontSize={'inherit'}/>
			</div>
		}
	</div>
})